import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, Plus, Trash2 } from "lucide-react";
import { useQuestionnaireEditor } from "@/hooks/use-questionnaire-editor";

export default function AIDealQuestionsSettings() {
  const {
    questions,
    isLoading,
    isDirty,
    isSaving,
    addQuestion,
    removeQuestion,
    updateQuestion,
    save,
  } = useQuestionnaireEditor();

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <>
    <div className="mx-auto max-w-2xl px-6 py-8 pb-24">
      <h1 className="text-lg font-semibold text-foreground">AI Deal Questions</h1>
      <p className="mt-0.5 text-sm text-muted-foreground">
        Tell DiligenceGPT what to evaluate on every deal.
      </p>

      <section className="mt-8">
        <div className="space-y-2">
          {questions.length > 0 ? (
            questions.map((question, index) => (
              <div
                key={index}
                className="flex items-center gap-3 rounded-lg border border-border bg-card p-3"
              >
                <Input
                  value={question}
                  onChange={(e) => updateQuestion(index, e.target.value)}
                  placeholder="Enter your question"
                  className="flex-1"
                />
                <Button
                  variant="ghost"
                  size="icon"
                  className="shrink-0 text-muted-foreground hover:text-destructive"
                  onClick={() => removeQuestion(index)}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            ))
          ) : (
            <div className="py-6 text-center text-sm text-muted-foreground">
              No questions added yet
            </div>
          )}
          <Button variant="outline" onClick={addQuestion}>
            <Plus className="mr-2 h-4 w-4" />
            Add Question
          </Button>
        </div>
      </section>

    </div>
    <div className="sticky bottom-0 border-t border-border bg-background/90 backdrop-blur">
      <div className="mx-auto flex max-w-2xl justify-end px-6 py-3">
        <Button onClick={() => save()} disabled={isSaving || !isDirty}>
          {isSaving ? "Saving..." : "Save Changes"}
        </Button>
      </div>
    </div>
    </>
  );
}
